import * as React from 'react';
import { ControlLabel, FormControl, FormGroup, Row } from 'react-bootstrap';

interface IProps {
    physFirstName: string,
    physLastName: string,
    physAddress: string,
    physCity: string,
    physState: string,
    physZipCode: string,
    physNpiNumber: string,
    handleInputChange: (e: React.FormEvent<FormControl & HTMLInputElement>) => void
}

class OrderingPhysician extends React.Component<IProps> {
    render = () => {
        return (
            <div className='col-sm-12'>
                <Row>
                    <div className='col-sm-6'>
                        <FormGroup controlId="physFirstName">
                            <ControlLabel>First Name</ControlLabel>
                            <FormControl
                                type="text"
                                name="physFirstName"
                                value={this.props.physFirstName}
                                placeholder="Physician First Name"
                                onChange={this.props.handleInputChange}
                            />
                            <FormControl.Feedback />
                        </FormGroup>
                    </div>

                    <div className='col-sm-6'>
                        <FormGroup controlId="physLastName">
                            <ControlLabel>Last Name</ControlLabel>
                            <FormControl
                                type="text"
                                name="physLastName"
                                value={this.props.physLastName}
                                placeholder="Physician Last Name"
                                onChange={this.props.handleInputChange}
                            />
                            <FormControl.Feedback />
                        </FormGroup>
                    </div>
                </Row>

                <Row>
                    <div className='col-sm-12'>
                        <FormGroup controlId="addressText">
                            <ControlLabel>Address</ControlLabel>
                            <FormControl
                                type="text"
                                name="physAddress"
                                value={this.props.physAddress}
                                placeholder="Street Address"
                                onChange={this.props.handleInputChange}
                            />
                            <FormControl.Feedback />
                        </FormGroup>
                    </div>
                </Row>

                <Row>
                    <div className='col-sm-4'>
                        <FormGroup controlId="cityText">
                            <ControlLabel>City</ControlLabel>
                            <FormControl
                                type="text"
                                name="physCity"
                                value={this.props.physCity}
                                placeholder="Enter city"
                                onChange={this.props.handleInputChange}
                            />
                            <FormControl.Feedback />
                        </FormGroup>
                    </div>
                    <div className='col-sm-4'>
                        <FormGroup controlId="stateText">
                            <ControlLabel>State</ControlLabel>
                            <FormControl
                                type="text"
                                name="physState"
                                maxLength={2}
                                value={this.props.physState}
                                placeholder="Enter state"
                                onChange={this.props.handleInputChange}
                            />
                            <FormControl.Feedback />
                        </FormGroup>
                    </div>
                    <div className='col-sm-4'>
                        <FormGroup controlId="zipCodeText">
                            <ControlLabel>Postal Code</ControlLabel>
                            <FormControl
                                type="text"
                                name="physZipCode"
                                value={this.props.physZipCode}
                                placeholder="Enter Postal Code"
                                onChange={this.props.handleInputChange}
                            />
                            <FormControl.Feedback />
                        </FormGroup>
                    </div>
                </Row>
                <Row>
                    <div className='col-sm-12'>
                        <FormGroup controlId="cityText">
                            <ControlLabel>NPI #</ControlLabel>
                            <FormControl
                                type="text"
                                name="physNpiNumber"
                                value={this.props.physNpiNumber}
                                placeholder="Enter Npi #"
                                onChange={this.props.handleInputChange}
                            />
                            <FormControl.Feedback />
                        </FormGroup>
                    </div>
                </Row>
            </div>
        )
    }
}

export default OrderingPhysician;